/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2022-12-15 15:44:43
 */
import React from 'react';
import { useIntl } from 'react-intl';

import messages from '../messages';
import Icon from 'root/components/Icon';
import { Button } from 'sup-ui';
import { useDispatch } from 'react-redux';
import { envManage } from 'root/pages/EnvManage/store/actions';
import { changeSystem } from 'root/store/fileConfig/actions';

import styles from '../index.less';

interface IProps {
  data: any; // 单条数据
  hasHost: boolean; // 是否有主机部署
}

const PackDetail = (props: IProps) => {
  const intl = useIntl();
  const { data = {}, hasHost } = props;
  const dispatch = useDispatch();

  const install = () => {
    const { name, fileName, archiveId } = data;
    dispatch(changeSystem({ name, fileName, archiveId }));
    window.hashHistory.push('/supos');
  };

  return (
    <div className={styles.pack_detail}>
      <div className={styles.shadow}>
        <div className={styles.pack_info}>
          <div className={styles.info}>
            <img className={styles.img} src={data.img} alt="" />
            <div className={styles.infoTitle}>
              <p className={styles.title}>{data.title}</p>
              <p className={styles.desc}>{data.version}</p>
            </div>
          </div>

          {hasHost ? (
            <div className={styles.tip}>
              <Button type="primary" size="small" onClick={install}>
                {intl.formatMessage(messages.visualInstallation)}
              </Button>
            </div>
          ) : (
            <div className={styles.tip}>
              <Icon type="tip16" className={styles.tipIcon} />
              {intl.formatMessage(messages.need)}
              <a
                onClick={() => {
                  dispatch(
                    envManage.changeEnvStatus({
                      acitveKey: '2',
                    }),
                  );
                }}
                className={styles.host}
              >
                {intl.formatMessage(messages.hostDeployment)}
              </a>
              ，{intl.formatMessage(messages.startInstallation)}
              <Button type="primary" size="small" disabled={true}>
                {intl.formatMessage(messages.visualInstallation)}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackDetail;
